import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService{

  static count:number =0
	 
	distancePoints(point1:any,point2:any) {
	    
	    return this.getDistanceFromLatLonInKm(point1.latitude,point1.longitude,point2.latitude,point2.longitude);
	    
	}
	 getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
		  var R = 6371; // Radius of the earth in km
		  var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
		  var dLon = this.deg2rad(lon2-lon1); 
		  var a = 
		    Math.sin(dLat/2) * Math.sin(dLat/2) +
		    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
		    Math.sin(dLon/2) * Math.sin(dLon/2)
		    ; 
		  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		  var d = R * c; // Distance in km
		  return d;
		}

		 deg2rad(deg) {
		  return deg * (Math.PI/180)
		}


	getDistanceAndTime(origin, destination): Observable<string>{
		
		 const data  = Observable.create(observer=> {

			var distanceService = new google.maps.DistanceMatrixService();		 
					distanceService.getDistanceMatrix({
								origins: [new google.maps.LatLng(origin.latitude, origin.longitude)],
								destinations: [new google.maps.LatLng(destination.latitude, destination.longitude)],
								travelMode: google.maps.TravelMode.DRIVING,
								unitSystem: google.maps.UnitSystem.METRIC,
								drivingOptions: {
									departureTime: new Date(Date.now() + 30000),  // for the time N milliseconds from now.
									trafficModel: 'optimistic'
								},
								avoidHighways: false,
								avoidTolls: false
						},
						function (response, status) {
								UtilsService.count ++;
								if (status !== google.maps.DistanceMatrixStatus.OK) {
										observer.next('');
										observer.complete();									
								} else {
										observer.next(
											response.rows[0].elements[0].distance.text + ' / ' +
											response.rows[0].elements[0].duration.text);
										observer.complete();
								}
						});

		 });
		 return data;
	}
	
	minutes(v: number) {
		return v * 60 * 1000;
	}

	removeTildes(texto) {
		return texto.normalize('NFD')
		.replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2")
		.normalize();
	}
	 
	toNumber(n: any){
		let aux:any = 0;
		try{
			aux = Number(n);
			if(Number.isNaN(aux)){
				aux = n.replace(',', '.');
				try{
					aux = Number(aux);
					if(Number.isNaN(aux)){
						aux = n.replace('.', ',');
						try{
							aux = Number(aux);
							if(Number.isNaN(aux))
								aux = '?';
						}catch(error){
							aux = '?';
						}
					}
				}catch(error){
					aux = '?';
				}
			}
		}catch(error){
			aux = '?';
		}
		return aux;
	}

	round(number, precision) {
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
	}

}
